import Cache from 'common/cache/lib/utils/Cache';

const getJwtExp = (jwtToken?: string): number | undefined => {
  if (!jwtToken || jwtToken === 'undefined') {
    return undefined;
  }

  try {
    const [, payloadSegment] = jwtToken.split('.');
    if (!payloadSegment) {
      return undefined;
    }

    const normalized = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(normalized));
    return typeof payload?.exp === 'number' ? payload.exp : undefined;
  } catch {
    return undefined;
  }
};

const getAccessTokenFromLoginInfo = (userLoginInfo: any): string =>
  userLoginInfo?.signInUserSession?.accessToken?.jwtToken || '';

const getCachedToken = (key: string): string => {
  const token = Cache.get(key);
  return token && token !== 'undefined' ? token : '';
};

const getCachedAccessToken = (): string => getCachedToken('accessToken');

const getCachedIdToken = (): string => getCachedToken('idToken');

export const isAccessTokenExpired = (
  userLoginInfo?: any,
  accessToken?: string,
): boolean => {
  const token = accessToken || getAccessTokenFromLoginInfo(userLoginInfo);
  const exp = getJwtExp(token);

  if (exp == null) {
    return true;
  }

  return Date.now() / 1000 > exp;
};

/**
 * Valid session = non-empty access token that has not expired.
 * Prefers the cached (refreshed) token over login-time loginInfo.
 */
export const hasValidAuthSession = (userLoginInfo?: any): boolean => {
  const accessToken =
    getCachedAccessToken() || getAccessTokenFromLoginInfo(userLoginInfo);

  if (!accessToken) {
    return false;
  }

  return !isAccessTokenExpired(userLoginInfo, accessToken);
};

export const hasStaleAuthCache = (): boolean =>
  Boolean(
    Cache.get('loginInfo') || getCachedAccessToken() || getCachedIdToken(),
  );
